import type { ObjectData, ZoneLink } from '@thottbot/shared';
import { ArtifactLink } from '../../components/ArtifactLink';
import { FieldTable, prose, refList } from './FieldTable';
import { Locations } from './Locations';
import { ZoneMap } from './ZoneMap';

export function ObjectFields({
  data,
  name,
  zone,
}: {
  data: ObjectData;
  name: string;
  zone?: ZoneLink;
}) {
  return (
    <FieldTable
      rows={[
        { label: 'Type', value: data.objectType },
        {
          label: 'Zone',
          value: data.zone && zone ? <ArtifactLink type="zone" slug={zone.slug} name={data.zone} /> : data.zone,
        },
        { label: 'Description', value: prose(data.description) },
        {
          label: 'Map',
          value: data.zone && data.locations?.length && (
            <ZoneMap
              zone={{ name: data.zone, areaId: zone?.areaId }}
              mapUrl={zone?.mapUrl}
              groups={[{ label: name, locations: data.locations }]}
            />
          ),
        },
        { label: 'Locations', value: <Locations locations={data.locations} /> },
        { label: 'Contains', value: refList(data.contains, 'item', data.lootedCount) },
        { label: 'Starts quests', value: refList(data.startsQuests, 'quest') },
        { label: 'Ends quests', value: refList(data.endsQuests, 'quest') },
      ]}
    />
  );
}
